// Global actions
export let SHOW_ERROR_TOAST = "SHOW_ERROR_TOAST";
export let RESET_TOAST = "RESET_TOAST";
export let UPDATE_PAGE_TITLE = "UPDATE_PAGE_TITLE"

// Auth actions
export let LOGIN = 'LOGIN';
export let UPDATE_TERM_AND_CONDITIONS = "UPDATE_TERM_AND_CONDITIONS"

// UI Config Actions
export let GET_GLOBAL_UI_CONFIG = "GET_GLOBAL_UI_CONFIG"
export let GET_CONSUMER_UI_CONFIG = "GET_CONSUMER_UI_CONFIG"
export let GET_BRANCH_UI_CONFIG = "GET_BRANCH_UI_CONFIG";
export let GET_FILTER_UI_CONFIG = "GET_FILTER_UI_CONFIG";
export let GET_FEES_UI_CONFIG = "GET_FEES_UI_CONFIG";
export let GET_PAYMENTS_UI_CONFIG = "GET_PAYMENTS_UI_CONFIG";
export let GET_FACILITY_UI_CONFIG = "GET_FACILITY_UI_CONFIG";
export let GET_DROP_DOWN_VALUE= "GET_DROP_DOWN_VALUE";
export let RESET_UI_DATA= "RESET_UI_DATA";

// Institute Actions
export let GET_ALL_INSTITUTES = "GET_ALL_INSTITUTES";
export let GET_INSTITUTE_CONFIGURATION = "GET_INSTITUTE_CONFIGURATION";
export let SEND_OTP = "SEND_OTP";
export let OTP_VERIFICATION = "OTP_VERIFICATION";
export let RESET_INSTITUTE_DATA = "RESET_INSTITUTE_DATA";
export let GET_PAYZAPP_BANNER = "GET_PAYZAPP_BANNER";
export let RESET_OTP_DATA = "RESET_OTP_DATA";
export let OTP_VERIFICATION_UNREGISTERED = "OTP_VERIFICATION_UNREGISTERED";
export let GET_ALL_SUPER_ENTITIES="GET_ALL_SUPER_ENTITIES";
export let GET_SUPER_ENTITY_CONFIG="GET_SUPER_ENTITY_CONFIG";

// Branch Actions
export let GET_ALL_BRANCHES_BY_INSTITUTE_ID = "GET_ALL_BRANCHES_BY_INSTITUTE_ID";
export let GET_BANNERS_BY_INSTITUTE_ID_AND_BRANCH_ID = "GET_BANNERS_BY_INSTITUTE_ID_AND_BRANCH_ID";
export let LIST_ACADEMIC_YEARS_BY_BRANCH_ID = "LIST_ACADEMIC_YEARS_BY_BRANCH_ID";
export let GET_BRANCH = "GET_BRANCH";
export let GET_BRANCH_LOGO = "GET_BRANCH_LOGO";
export let RESET_BRANCH_DATA = "RESET_BRANCH_DATA";
export let GET_CAPTACHA_VALUE = "GET_CAPTACHA_VALUE";
export let GET_BANK_BRANDING = "GET_BANK_BRANDING";

// Student actions
export let SEARCH_STUDENT = "SEARCH_STUDENT";
export let GET_STUDENT_DETAILS = "GET_STUDENT_DETAILS";
export let UPDATE_SUNMMARY = "UPDATE_SUNMMARY";
export let RESET_STUDENT_DETAILS = "RESET_STUDENT_DETAILS";
export let GET_STUDENT_BY_ID = "GET_STUDENT_BY_ID";

// Payments actions
export let RESET_PAYMENT_STATUS = "RESET_PAYMENT_STATUS";
export let RESET_PRINT_RECIEPT_DATA = "RESET_PRINT_RECIEPT_DATA";
export let GET_PAID_FEES_BY_QFIX_REFERENCE_NUMBER = "GET_PAID_FEES_BY_QFIX_REFERENCE_NUMBER";
export let GET_PAID_FEES_BY_PAYMENT_GATEWAY_TRANSACTION_ID = "GET_PAID_FEES_BY_PAYMENT_GATEWAY_TRANSACTION_ID";
export let GET_APP_INFO = "GET_APP_INFO";
export let GET_FEE_FINANCE = "GET_FEE_FINANCE";
export let GET_FEE_TYPE="GET_FEE_TYPE"
export let RESET_UNPAID_FEES="RESET_UNPAID_FEES"
export let RESET_PAID_FEES_DATA="RESET_PAID_FEES_DATA"



//Registration Actions
export let GET_FORM_LIST = "GET_FORM_LIST";
export let GET_DEFAULT_FORM = "GET_DEFAULT_FORM";
export let GET_FORM_STRUCTURE = "GET_FORM_STRUCTURE";
export let GET_STANDARD_DIVISION_CAST = "GET_STANDARD_DIVISION_CAST";
export let GET_STATE_LIST = "GET_STATE_LIST";
export let GET_DISTRICT_LIST = "GET_DISTRICT_LIST";
export let SAVE_STUDENT = "SAVE_STUDENT";
export let RESETE_PAYDIRECT_DATA = "RESETE_PAYDIRECT_DATA";
export let GET_FILTER_DROPDOWN_VALUE = "GET_FILTER_DROPDOWN_VALUE";
export let GET_CUSTOM_FIELD_DROPDOWN_VALUE = "GET_CUSTOM_FIELD_DROPDOWN_VALUE";
export let RESET_REGISTRATION_UPDATE_DATA = "RESET_REGISTRATION_UPDATE_DATA";

export let GET_UNPAID_FEES = "GET_UNPAID_FEES";
export let GET_FEE_INFO = "GET_FEE_INFO";
export let GET_PRINT_RECIEPT_DATA = "GET_PRINT_RECIEPT_DATA";
export let GET_FEES_BREAKUP = "GET_FEES_BREAKUP";
export let GET_STANDING_INSTRUCTION = "GET_STANDING_INSTRUCTION";
export let GET_STANDING_INSTRUCTION_VIEW = "GET_STANDING_INSTRUCTION_VIEW";
export let DELETE_STANDING_INSTRUCTION = "DELETE_STANDING_INSTRUCTION";
export let GET_UPI_MANDATE = "GET_UPI_MANDATE";
export let REVOKE_UPI_MANDATE = "REVOKE_UPI_MANDATE";
export let SUBMIT_DUES_REMARKS = "SUBMIT_DUES_REMARKS";
export let INIT_PAYMENT = "INIT_PAYMENT";
export let GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS";
export let EMAIL_RECEIPT = "EMAIL_RECEIPT";
export let GET_ADDITIONAL_FEES = "GET_ADDITIONAL_FEES"
export let APPLY_ADDITIONAL_FEES = "APPLY_ADDITIONAL_FEES"
export let DELETE_ADDITIONAL_FEES = "DELETE_ADDITIONAL_FEES";
export let APPLY_FIRST_TIME_ADDITIONAL_FEES = "APPLY_FIRST_TIME_ADDITIONAL_FEES";
export let SEARCH_FEES_BY_RULE = "SEARCH_FEES_BY_RULE";
export let GET_COLLECT_FEES_DETAILS = "GET_COLLECT_FEES_DETAILS";
export let SAVE_UNREGISTERED_USER = "SAVE_UNREGISTERED_USER";

export let GET_ENCODED_KEY = "GET_ENCODED_KEY";
export let SEARCH_ERP_STUDENT = "SEARCH_ERP_STUDENT";

/**
 * Add all of your actions above these functions.
 *
 * @export
 * @param {*} action
 * @returns
 */
export function pending(action) {
    return action + "_PENDING";
}

export function fulfilled(action) {
    return action + "_FULFILLED";
}

export function rejected(action) {
    return action + "_REJECTED";
}